var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5239_1227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4787 25.431C20.3866 25.431 25.9866 19.831 25.9866 12.923C25.9866 6.01504 20.3866 0.415039 13.4787 0.415039C6.57071 0.415039 0.970703 6.01504 0.970703 12.923C0.970703 19.831 6.57071 25.431 13.4787 25.431Z",
    fill: "#CD4141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7852 6.66895H15.1988V13.9653H11.7852V6.66895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4789 19.1766C14.4144 19.1766 15.1727 18.4183 15.1727 17.4828C15.1727 16.5474 14.4144 15.7891 13.4789 15.7891C12.5435 15.7891 11.7852 16.5474 11.7852 17.4828C11.7852 18.4183 12.5435 19.1766 13.4789 19.1766Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5239_1227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.2765,
    height: 25.2765,
    fill: "white",
    transform: "translate(0.840332 0.285156)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlert);
export default __webpack_public_path__ + "static/media/errorAlert.b759da99cfff8f71e38c2a91bf41ea05.svg";
export { ForwardRef as ReactComponent };